import { api } from "./api";

export interface WishlistItem {
  _id: string;
  user: string;
  course: {
    _id: string;
    title: string;
    thumbnail: string;
    price: number;
    discount: number;
    slug: string;
    instructorName?: string;
    rating?: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface WishlistResponse {
  success: boolean;
  count: number;
  data: WishlistItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const wishlistApi = {
  // Add course to wishlist
  addToWishlist: (courseId: string) => {
    return api.post<{ success: boolean; message: string; data: WishlistItem }>(
      `/wishlist/${courseId}`
    );
  },

  // Remove course from wishlist
  removeFromWishlist: (courseId: string) => {
    return api.delete<{ success: boolean; message: string }>(
      `/wishlist/${courseId}`
    );
  },

  // Get user's wishlist
  getMyWishlist: (options?: { page?: number; limit?: number }) => {
    const params = new URLSearchParams();
    if (options?.page) params.append("page", String(options.page));
    if (options?.limit) params.append("limit", String(options.limit));
    
    return api.get<WishlistResponse>(
      `/wishlist${params.toString() ? `?${params.toString()}` : ""}`
    );
  },

  // Check if course is in wishlist
  isInWishlist: (courseId: string) => {
    return api.get<{ success: boolean; data: boolean }>(
      `/wishlist/check/${courseId}`
    );
  },
};